export enum WoundConsistencyEnum {
  Thin = 1,
  Thick = 2,
  Other = 99
}

export const WoundConsistencyOptions = [
{ id: 1, label: 'Thin' },
{ id: 2, label: 'Thick' },
{ id: 99, label: 'Other' }
];
